import React, { Component } from 'react'
import ErrorAlert from './errorAlert'
import FeedTable from './feedTable'
import { connect } from 'react-redux'
import { GET_FEEDS } from '../../../../../actions/manageFeedsAction';
import ManageFeedEmpty from './manageFeedEmpty'
import { createFeed, isAppleSafari } from '../../../../../utils';
import { closePricingModal } from '../../../../../utils/close_modal' 
import { addUserAccount } from '../../../../Authorization/SocialAuth/connectSocialAcc';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';
import LoadingScreen from '../../../../CommonComponents/LoadingScreen';
import { Button } from 'react-bootstrap';

const channel = isAppleSafari() ? window : new BroadcastChannel('connect');
class Managefeeds extends Component {

    state = { addFeed: false, errorMsg: false, loading: true }

    componentWillMount() { this.getFeed(); }

    componentDidMount() { channel.addEventListener('message', this.readAuthenticationCode) }

    feedRconnect = () => this.setState({ errorMsg: true })

    stopLoader = () => this.setState({ loading: false })

    getUpdatedData = () => this.setState({ loading: true }, () => { this.props.GET_FEEDS(this.stopLoader); })
    
    getFeed = () => {
        this.props.GET_FEEDS(this.stopLoader);
    }

    readAuthenticationCode = (event) => {
        const response = JSON.parse(event.data);
        const { data, networkId,type} = response;

        const feedId = localStorage.getItem('feed_id');
        const reconnect = localStorage.getItem('refresh');
        
        if(type == "manageFeed") addUserAccount(networkId, data, () => this.getUpdatedData(),localStorage.getItem('ownerId'),0,Number(reconnect),Number(feedId));
        
        localStorage.removeItem('feed_id');
        localStorage.removeItem('refresh');
    }

    componentWillUnmount() { channel.removeEventListener("message", this.readAuthenticationCode); }


    render() {

        const { feeds, closeModal } = this.props
        const { errorMsg, loading } = this.state;
        const restallFeeds = feeds?.filter(feed => ![29, 30].includes(feed.networkId));
        return (
            <>
                {
                    !loading ?
                        <div className="add-feed-modal ModelCreatedFeed">
                            {/* ----------Header----------- */}
                            <div className="d-flex align-items-center justify-content-between border-bottom page_custom_header">
                                <div className="d-flex align-items-center flex-nowrap">
                                    <Button variant='link' onClick={() => closeModal()} className="me-3 border-end border-0 p-3 rounded-0 previous-step">
                                        <FontAwesomeIcon icon={'chevron-left'} iconClass={'p-0'} />
                                    </Button>
                                    <h5 className="m-0 text-nowrap overflow-hidden" id="feed_title">Manage Feeds</h5>
                                </div>
                                <div className="d-flex align-items-center justify-content-end close_btn">
                                    <Button variant='link' className="p-3" onClick={() => closeModal()} >
                                        <FontAwesomeIcon type={'solid'} icon={'xmark'} />
                                    </Button>
                                </div>
                            </div>
                            {/* -------------body---------- */}

                            {restallFeeds && restallFeeds.length > 0 ?

                                <div className="add-feed-modal-body">
                                    <div className="container">
                                        <div id="feed_content__">
                                            <div className="py-5">
                                                {/* ----------errorMsg---------- */}
                                                {errorMsg ? <ErrorAlert /> : null}
                                                <div className="contntManageFeeds feedWrapC">
                                                    <div className="card card-custom">
                                                        <div className="card-header flex-wrap p-4">
                                                            <div className="card-title">
                                                                <h3 className="card-label">Feed List</h3>
                                                            </div>
                                                            <div className="card-toolbar">
                                                                <Button variant='primary' onClick={(e) => this.props.createFeed() /*this.setState({ addFeed: true })*/}>
                                                                    <FontAwesomeIcon type={'regular'} icon={'plus'} iconClass={'me-2'} />
                                                                    Add Feed
                                                                </Button>
                                                            </div>
                                                        </div>

                                                        {restallFeeds ?
                                                            <div className="card-body pt-5 pb-4">
                                                                <FeedTable feedRconnect={this.feedRconnect} feeds={restallFeeds} onFeedDelete={this.onFeedDelete} getFeed={this.getFeed}/>
                                                            </div> : null}

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                : <ManageFeedEmpty />}
                        </div>
                        :

                        <LoadingScreen />
                }

            </>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        loadComonent: state.manageFeeds.feeds ? '1' : '',
        feeds: state.manageFeeds.feeds,
        addFeedData: state.moderation.addFeedNetworks ? state.moderation.addFeedNetworks : []
    }
}
const mapDispatchToProps = dispatch => {
    return {
        GET_FEEDS: (stopLoader) => dispatch(GET_FEEDS(stopLoader)),
        closeModal: () => closePricingModal(dispatch),
        createFeed: () => createFeed(dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Managefeeds);
